export const SUPPORT_EMAIL = "support@pull-up-app.com";
export const SITE_DOMAIN = "pull-up-app.com";
export const APP_STORE_URL = "#app-store-link-pending";
export const GOOGLE_PLAY_URL = "#google-play-link-pending";
export const BUSINESS_EMAIL = `mailto:${SUPPORT_EMAIL}?subject=Pull%20Up%20for%20Business`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1778501138411-7fe640ed26d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxmcmllbmRzJTIwbGF1Z2hpbmclMjBuaWdodCUyMHN0cmVldHxlbnwwfHx8fDE3ODk0OTAyMTd8MA&ixlib=rb-4.1.0&q=85",
  coffee: "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMHBlb3BsZSUyMGdhdGhlcmluZyUyMGNvZmZlZXxlbnwwfHx8fDE3ODk0OTAyMTd8MA&ixlib=rb-4.1.0&q=85",
  rooftop: "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxyb29mdG9wJTIwcGFydHklMjBmcmllbmRzfGVufDB8fHx8MTc4OTQ5MDIyMXww&ixlib=rb-4.1.0&q=85",
  night: "https://images.unsplash.com/photo-1778501145215-0485e57dd8b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxmcmllbmRzJTIwbGF1Z2hpbmclMjBuaWdodCUyMHN0cmVldHxlbnwwfHx8fDE3ODk0OTAyMTd8MA&ixlib=rb-4.1.0&q=85",
  deck: "https://images.unsplash.com/photo-1695128751971-b3b050b5e13e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxyb29mdG9wJTIwcGFydHklMjBmcmllbmRzfGVufDB8fHx8MTc4OTQ5MDIyMXww&ixlib=rb-4.1.0&q=85",
};

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
